export const FEATURE_FLAGS = {
  ADD_FREIGHT_LIMITED: 'Flag_AddFreight_Limited',
  DISABLE_REVIEWS: 'Flag_DisableReviews'
}
